<template>
	<div>
		<FormulateInput
			v-model="context.model"
			autocomplete="no"
			input-class="form-control"
			outer-class=""
			element-class="input-group"
			:name="context.name"
			:type="context.classification"
			:placeholder="context.attributes.placeholder"
			:validation="context.validation"
			:validation-name="context.validationName"
			:validation-messages="context.validationMessages"
			:step="context.attributes.step"
			:min="context.attributes.min"
			:max="context.attributes.max"
			@blur="context.blurHandler">
		</FormulateInput>

		<div v-if="isValid" class="small text-green mt-2">
			This is a valid N-Number registered with the FAA under: <strong class="text-nowrap">{{ registration.name }}</strong>.
		</div>

		<div v-if="!isValid && context.model" class="small text-warning mt-2">
			The N-Number entered may be invalid, if your aircraft is not registered please contact USUA for a Registration number.
		</div>
	</div>
</template>
<script>
import _ from 'lodash'
import api from '@/lib/api'
import formInvalid from '@/Pages/Forms/Mixins/FormInvalid'

export default {
	mixins: [formInvalid],

	props: {
		context: {
			type: Object,
			required: true
		}
	},

	data () {
		return {
			isValid: null,
			registration: {}
		}
	},

	watch: {
		'context.model': {
			handler: _.debounce(function () {
				this.validateNumber()
			}, 250)
		}
	},

	mounted () {
		this.validateNumber()
	},

	methods: {
		validateNumber () {
			this.isValid = null
			this.registration = {}

			if(! this.context.model) {
				return
			}

			const url = this.route('form.utilities.faa.search')

			const method = 'POST'
			const data = {
				n_number: this.context.model
			}

			return api({method, url, data}).then(response => {
				if(! this.exists(response.data)) {
					this.isValid = false

					return
				}

				if(response.data.id !== undefined) {
					this.isValid = true
					this.registration = response.data
				}
			}).catch(err => {
				console.error(err)
			})
		}
	}
}
</script>
